import ContextualMenu, {
  ContextualMenuProps,
} from "../ContextualMenu/ContextualMenu";
import Button, { ButtonProps } from "../Button/Button";
import Icon from "../Icon/Icon";
import { Text } from "../typography/Text";
import { IconName } from "@zenchef/icomoon";

import { Menu } from "@ark-ui/react";
import { AromaButtonVariantProps } from "@zenchef/styled-system/recipes";
import { Badge } from "../..";
import { HStack } from "@zenchef/styled-system/jsx";

interface FilterTriggerProps
  extends Pick<AromaButtonVariantProps, "active">,
    Pick<ButtonProps, "disabled"> {
  triggerLabel?: string;
  badgeCount?: number;
  filterIcon?: IconName;
}

const FilterTrigger = ({
  triggerLabel,
  active,
  badgeCount,
  filterIcon,
  ...props
}: FilterTriggerProps) => {
  return (
    <Menu.Context>
      {({ open }) => (
        <Button
          hierarchy="secondary-subtle"
          iconOnly={!triggerLabel}
          active={active}
          data-active={open || undefined}
          {...props}
        >
          {(triggerLabel ?? badgeCount) ? (
            <HStack gap="gap.1">
              {triggerLabel ? <Text>{triggerLabel}</Text> : null}
              {badgeCount ? <Badge>{badgeCount}</Badge> : null}
            </HStack>
          ) : null}
          <Icon
            name={
              filterIcon ? filterIcon : open ? "chevron-up" : "chevron-down"
            }
          />
        </Button>
      )}
    </Menu.Context>
  );
};

export interface BaseFilterProps
  extends Omit<ContextualMenuProps, "trigger">,
    FilterTriggerProps {}

const BaseFilter = ({
  children,
  items,
  sections,
  triggerLabel,
  active,
  disabled,
  badgeCount,
  filterIcon,
  ...props
}: BaseFilterProps) => {
  const commonProps: Omit<
    ContextualMenuProps,
    "children" | "items" | "sections" | "onSetValue"
  > = {
    ...props,
    trigger: (
      <Menu.Indicator>
        <FilterTrigger
          triggerLabel={triggerLabel}
          active={active}
          disabled={disabled}
          badgeCount={badgeCount}
          filterIcon={filterIcon}
        />
      </Menu.Indicator>
    ),
  };

  if (sections) {
    return <ContextualMenu {...commonProps} sections={sections} />;
  }

  if (!items) {
    return <ContextualMenu {...commonProps}>{children}</ContextualMenu>;
  }

  return <ContextualMenu {...commonProps} items={items} />;
};

export default BaseFilter;
